<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import {payType} from "@/utils/config";
import store from "@/store";
import axiosApi from "@/utils/axiosApi";
import {ElMessage} from "element-plus";

const props = defineProps({
  product: {
    type: Object
  },
  showProduct: {
    type: Boolean,
    default: true
  },
})
const emit = defineEmits(['payProduct', 'close'])
const type = computed(() => {
  return payType.xm_air
})
const loading = ref(false)
const number = ref(1)
const account = computed(() => store.state.account)
onMounted(() => {
  store.commit("getAccount")
})
const pay_score = computed(() => {
  return props.product.dis_score * number.value
})
const maxNumber = computed(() => {
  return Math.floor(account.value.balance_miles / props.product.dis_score)
})

const pay = () => {
  loading.value = true
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: props.product.id,
      uid: account.value.uid,
      pay_type: "xm_air",
      pay_params: JSON.stringify({
        access_token: account.value.access_token,
        user_id: account.value.user_id
      }),
      number: number.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000") {
      return ElMessage.error(res.message.msg)
    }
    emit('close')
    window.location.href = res.data.url
  }, () => loading.value = false)
  // emit('payProduct', {product: props.product, number})
}
</script>

<template>
  <el-drawer class="xiamen-product-drawer" v-model="props.showProduct" direction="btt" :style="type.view" size="360px"
             @close="emit('close')">
    <template #header>
      <div class="xiamen-product-header" :style="{backgroundImage:`url('${type.logo}')`}">
        <h3>机场高铁10元消费券</h3>
        <div><span class="score-text">{{ props.product.dis_score }}</span>积分</div>
      </div>
    </template>

    <el-card style="margin-bottom: 15px">
      <div class="xiamen-product-content">
        <div class="xiamen-product-content-label">
          可用积分
        </div>
        <div class="xiamen-product-content-value">
          {{ account.balance_miles }}
        </div>
      </div>
      <div class="xiamen-product-content">
        <div class="xiamen-product-content-label">
          购买数量
        </div>
        <div class="xiamen-product-content-value">
          <el-input-number v-model="number" :min="1" :max="maxNumber"/>
        </div>
      </div>
      <div class="xiamen-product-content">
        <div class="xiamen-product-content-label">
          支付积分
        </div>
        <div class="xiamen-product-content-value">
          {{ pay_score }}
        </div>
      </div>
    </el-card>
    <el-button type="primary" color="var(--btn-color)" round size="large" @click="pay"
               :disabled="pay_score > account.balance_miles" :loading="loading">立即兑换
    </el-button>
  </el-drawer>
</template>

<style lang="less">
.xiamen-product-drawer {
  border-radius: 16px 16px 0 0;

  .el-drawer__header {
    margin-bottom: 0;
  }

  .xiamen-product-header {
    line-height: 1.75;

    background-repeat: no-repeat;
    background-size: auto 65%;
    background-position: right;

    .score-text {
      font-size: 1.43rem;
      color: var(--text-color);
    }
  }

  .el-button {
    width: 100%;
  }
}

.xiamen-product-content {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;

  & + .xiamen-product-content {
    border-top: var(--el-border);
  }
}
</style>
